<!-- Brand Logo -->
<a [routerLink]="['/']" class="brand-link text-center">
    <img src="../../../../assets/img/budget-logo.png" alt="Budget bazaar Logo" class="brand-image" style="opacity: 0.8">
    <!--<span class="brand-text font-weight-bolder">Lovely Fashion</span>-->
</a>

<!-- Sidebar -->
<div class="sidebar">
    <!-- Sidebar user (optional) -->
    <!--<div
        class="user-panel mt-3 pb-2 d-flex"
        style="justify-content: start; align-items: center"
    >
        &lt;!&ndash;<pf-image
            [src]="user.photoURL"
            fallbackSrc="assets/img/default-profile.png"
            style="margin-left: 12px"
            alt="User Image"
            width="34"
            height="34"
            rounded="true"
        />&ndash;&gt;
        <div class="info">
           &lt;!&ndash; <a [routerLink]="['/profile']" class="d-block">
                {{ user.email }}
            </a>&ndash;&gt;
        </div>
    </div>

    <div class="form-inline">
        <app-sidebar-search></app-sidebar-search>
    </div>-->

    <!-- Sidebar Menu -->
    <nav class="mt-2" style="overflow-y: hidden">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            <app-menu-item *ngFor="let item of menu" [menuItem]="item" />
        </ul>
    </nav>
</div>